import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
import { Session } from '.';

export default class SessionsTree extends BaseAPIModel {
    static list(item) {
        return this.fromJSON(item);
    }

    static browseTree(children) {
        return (
            children.map?.(group => {
                group.sessions = group.sessions.map?.(session => Session.fromJSON(session));
                group.children = this.browseTree(group.children);
                return Session.fromJSON(group);
            }) ?? []
        );
    }

    static fromJSON(data) {
        const tree = super.fromJSON(data);
        // tree.children = this.browseTree(data.root);
        tree.sessions = data.map?.(session => Session.fromJSON(session));
        return tree;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/sessions`;
    }
    // static getAll(...args) {
    //     return new Promise((resolve, reject) => resolve(this.list(demoData)));
    // }

    // Get the select options object for this tree with groups
    toOptions(options, _groups = null, _depth = 0) {
        const { extraSession, filter = () => true } = options;
        return this.sessions.filter?.(filter).map?.(session => session.toOption(extraSession));
    }
}
